import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

// Legacy Stripe success page - redirect to new Mercado Pago pages
const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new success page
    const ref = searchParams.get('ref') || searchParams.get('external_reference') || '';
    navigate(`/pagamento/sucesso?ref=${ref}`, { replace: true });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center">
      <div className="text-white">Redirecionando...</div>
    </div>
  );
};

export default CheckoutSuccessPage;
